import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/transportList/history',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/transportList/detail',
    method: 'get',
    params: data,
  })
}
export async function approvalProcess(data) {
  return request({
    url: '/transportList/checkProcessInfo',
    method: 'post',
    data,
  })
}